import { createContext } from 'react'

import type { UseMenuItemProviderReturn } from './use-menu-item'

export type MenuItemContext = Partial<UseMenuItemProviderReturn>

export const MenuItemContext = createContext<MenuItemContext>({})
